import {Provider} from '@oilstone/container';
import {RestModel} from '@oilstone/rest-model';

export default new Provider().register(() => {
    RestModel.setBaseUrl(process.env.VUE_APP_API_URL);
});
